// import React, { useEffect } from "react";
// import { EditOutlined } from "@ant-design/icons";
// import { Button, Form, Input } from "antd";
// import ButtonWrapper from "../../components/reuseComp/ButtonWrapper";

// const { TextArea } = Input;

// interface AboutIntroData {
//   heading?: string;
//   description?: string;
//   videoUrl?: string;
// }

// interface AboutIntroProps {
//   isEditing: boolean;
//   setIsEditing: (value: boolean) => void;
//   handleCancel: () => void;
//   handleSave: () => void;
//   form: any;
//   aboutIntroData?: AboutIntroData;
//   loading?: boolean;
// }

// const AboutIntro: React.FC<AboutIntroProps> = ({
//   isEditing,
//   setIsEditing,
//   handleCancel,
//   handleSave,
//   form,
//   aboutIntroData,
//   loading,
// }) => {
//   useEffect(() => {
//     if (aboutIntroData) {
//       form.setFieldsValue({
//         aboutIntro: {
//           heading: aboutIntroData.heading || "",
//           description: aboutIntroData.description || "",
//           videoUrl: aboutIntroData.videoUrl || "",
//         },
//       });
//     } else {
//       form.resetFields();
//     }
//   }, [aboutIntroData, form]);

//   return (
//     <div>
//       {!isEditing ? (
//         <>
//           {/* Desktop Table */}

//           <div className="rounded-[20px] overflow-hidden hidden sm:block">
//             <table className="min-w-full border-collapse">
//               <thead>
//                 <tr className="bg-primary text-white">
//                   <th className="py-3 px-4 text-left">Heading</th>
//                   <th className="py-3 px-4 text-left">Description</th>
//                   <th className="py-3 px-4 text-left">Video URL</th>
//                   <th className="py-3 px-4 text-end">Action</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {aboutIntroData?.heading ? (
//                   <tr className="bg-[#F9F9F9] border-b-2 border-[#e9e8e8]">
//                     <td className="py-3 px-4">
//                       {aboutIntroData.heading || "—"}
//                     </td>

//                     <td className="py-3 px-4">
//                       {aboutIntroData.description || "—"}
//                     </td>

//                     <td className="py-3 px-4">
//                       {aboutIntroData.videoUrl || "—"}
//                     </td>

//                     <td className="py-3 px-4 text-end text-primary">
//                       <EditOutlined
//                         onClick={() => setIsEditing(true)}
//                         className="cursor-pointer text-[20px]"
//                       />
//                     </td>
//                   </tr>
//                 ) : (
//                   <tr className="bg-[#F9F9F9] border-b-2 border-[#e9e8e8]">
//                     <td colSpan={4} className="text-center py-6">
//                       <Button type="dashed" onClick={() => setIsEditing(true)}>
//                         Add Data
//                       </Button>
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>

//           {/* Mobile View */}

//           <div className="sm:hidden">
//             {aboutIntroData?.heading ? (
//               <div className="bg-[#F9F9F9] border rounded-lg p-4 space-y-3">
//                 <div>
//                   <span className="font-semibold text-primary block">
//                     Heading
//                   </span>
//                   {aboutIntroData.heading}
//                 </div>

//                 <div>
//                   <span className="font-semibold text-primary block">
//                     Description
//                   </span>
//                   {aboutIntroData.description}
//                 </div>

//                 <div>
//                   <span className="font-semibold text-primary block">
//                     Video URL
//                   </span>
//                   {aboutIntroData.videoUrl}
//                 </div>

//                 <EditOutlined
//                   onClick={() => setIsEditing(true)}
//                   className="cursor-pointer text-[18px]"
//                 />
//               </div>
//             ) : (
//               <div className="flex justify-center border rounded-lg p-4">
//                 <Button type="dashed" onClick={() => setIsEditing(true)}>
//                   Add Data
//                 </Button>
//               </div>
//             )}
//           </div>
//         </>
//       ) : (
//         /* Edit Mode */

//         <div>
//           <div className="bg-[#F9F9F9] p-4 sm:p-6 rounded-lg sm:rounded-2xl shadow-sm">
//             <Form layout="vertical" form={form}>
//               <Form.Item
//                 label="Heading"
//                 name={["aboutIntro", "heading"]}
//                 rules={[{ required: true, message: "Please enter heading" }]}
//               >
//                 <Input placeholder="Enter heading" />
//               </Form.Item>

//               <Form.Item
//                 label="Description"
//                 name={["aboutIntro", "description"]}
//                 rules={[
//                   { required: true, message: "Please enter description" },
//                 ]}
//               >
//                 <TextArea rows={3} placeholder="Enter description" />
//               </Form.Item>

//               <Form.Item
//                 label="Video URL"
//                 name={["aboutIntro", "videoUrl"]}
//                 rules={[
//                   { required: true, message: "Please enter video url" },
//                 ]}
//               >
//                 <Input placeholder="Enter video url" />
//               </Form.Item>
//             </Form>
//           </div>

//           <div className="flex gap-3 mt-6 sticky bottom-5">
//             <ButtonWrapper
//               type="primary"
//               onClick={handleSave}
//               loading={loading}
//             >
//               Save
//             </ButtonWrapper>

//             <ButtonWrapper onClick={handleCancel}>Cancel</ButtonWrapper>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AboutIntro;


import React, { useEffect } from "react";
import { EditOutlined } from "@ant-design/icons";
import { Button, Form, Input } from "antd";
import ButtonWrapper from "../../components/reuseComp/ButtonWrapper";
import UploadFoodImage from "../../../lib/UploadFoodImage";

const { TextArea } = Input;

interface AboutIntroData {
  heading?: string;
  description?: string;
  videoUrl?: string;
}

interface AboutIntroProps {
  isEditing: boolean;
  setIsEditing: (value: boolean) => void;
  handleCancel: () => void;
  handleSave: () => void;
  form: any;
  aboutIntroData?: AboutIntroData;
  loading?: boolean;
}

const AboutIntro: React.FC<AboutIntroProps> = ({
  isEditing,
  setIsEditing,
  handleCancel,
  handleSave,
  form,
  aboutIntroData,
  loading,
}) => {
  useEffect(() => {
    if (aboutIntroData) {
      form.setFieldsValue({
        about: {
          heading: aboutIntroData.heading || "",
          description: aboutIntroData.description || "",
          videoUrl: aboutIntroData.videoUrl || "",
        },
      });
    } else {
      form.resetFields();
    }
  }, [aboutIntroData, form]);

  return (
    <div>
      {!isEditing ? (
        <>
          {/* Desktop Table */}
          <div className="rounded-[20px] overflow-hidden hidden sm:block">
            <table className="min-w-full border-collapse">
              <thead>
                <tr className="bg-primary text-white">
                  <th className="py-3 px-4 text-left">Heading</th>
                  <th className="py-3 px-4 text-left">Description</th>
                  <th className="py-3 px-4 text-center">Video</th>
                  <th className="py-3 px-4 text-end">Action</th>
                </tr>
              </thead>

              <tbody>
                {aboutIntroData?.heading ? (
                  <tr className="bg-[#F9F9F9] border-b-2 border-[#e9e8e8]">
                    <td className="py-3 px-4">
                      {aboutIntroData.heading || "—"}
                    </td>

                    <td className="py-3 px-4">
                      {aboutIntroData.description || "—"}
                    </td>

                    <td className="py-3 px-4 text-center">
                      {aboutIntroData.videoUrl ? (
                        <video
                          src={aboutIntroData.videoUrl}
                          className="h-[60px] mx-auto"
                          controls
                        />
                      ) : (
                        "—"
                      )}
                    </td>

                    <td className="py-3 px-4 text-end text-primary">
                      <EditOutlined
                        onClick={() => setIsEditing(true)}
                        className="cursor-pointer text-[20px]"
                      />
                    </td>
                  </tr>
                ) : (
                  <tr className="bg-[#F9F9F9] border-b-2 border-[#e9e8e8]">
                    <td colSpan={4} className="text-center py-6">
                      <Button type="dashed" onClick={() => setIsEditing(true)}>
                        Add Data
                      </Button>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Mobile View */}
          <div className="sm:hidden">
            {aboutIntroData?.heading ? (
              <div className="bg-[#F9F9F9] border rounded-lg p-4 space-y-3">
                <div>
                  <span className="font-semibold text-primary block">
                    Heading
                  </span>
                  {aboutIntroData.heading}
                </div>

                <div>
                  <span className="font-semibold text-primary block">
                    Description
                  </span>
                  {aboutIntroData.description}
                </div>

                <div>
                  <span className="font-semibold text-primary block">
                    Video
                  </span>
                  {aboutIntroData.videoUrl && (
                    <video
                      src={aboutIntroData.videoUrl}
                      className="h-[80px]"
                      controls
                    />
                  )}
                </div>

                <EditOutlined
                  onClick={() => setIsEditing(true)}
                  className="cursor-pointer text-[18px]"
                />
              </div>
            ) : (
              <div className="flex justify-center border rounded-lg p-4">
                <Button type="dashed" onClick={() => setIsEditing(true)}>
                  Add Data
                </Button>
              </div>
            )}
          </div>
        </>
      ) : (
        /* Edit Mode */
        <div>
          <div className="bg-[#F9F9F9] p-4 sm:p-6 rounded-lg sm:rounded-2xl shadow-sm">
            <Form layout="vertical" form={form}>
              <Form.Item
                label="Heading"
                name={["about", "heading"]}
                rules={[{ required: true, message: "Please enter heading" }]}
              >
                <Input placeholder="Enter heading" />
              </Form.Item>

              <Form.Item
                label="Description"
                name={["about", "description"]}
                rules={[
                  { required: true, message: "Please enter description" },
                ]}
              >
                <TextArea rows={3} placeholder="Enter description" />
              </Form.Item>

              {/* ✅ Replaced Input with Upload */}
              <Form.Item
                label="Upload Video"
                name={["about", "videoUrl"]}
                rules={[
                  { required: true, message: "Please upload video" },
                ]}
              >
                <UploadFoodImage accept="video/*" maxUploadCount={1}/>
              </Form.Item>
            </Form>
          </div>

          <div className="flex gap-3 mt-6 sticky bottom-5">
            <ButtonWrapper
              type="primary"
              onClick={handleSave}
              loading={loading}
            >
              Save
            </ButtonWrapper>

            <ButtonWrapper onClick={handleCancel}>Cancel</ButtonWrapper>
          </div>
        </div>
      )}
    </div>
  );
};

export default AboutIntro;